<app-role-log
    [roles]="roles$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async">
</app-role-log>
